// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe[data-v-1d99a00c]{width:100%;height:100vh}`, "",{"version":3,"sources":["webpack://./../common/components/TemplateVersions/Versions.vue"],"names":[],"mappings":"AACA,wBACE,UAAA,CACA,YAAA","sourcesContent":["\niframe {\n  width: 100%;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
